import { footerStyles as styles } from "@insite/content-library/Pages/Footer";
import { css } from "styled-components";

styles.page = {
    ...styles.page,
    css: css`
    max-width: 100% !important;
    padding: 15px 0 0 0 !important;
    `,
};
